var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.ready)?_c('Row',[_c('Column',[_c('VehicleImage',{attrs:{"size":"width:150px;","defaultValue":_vm.row.valueAsObject()}})],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }